import { ApiClient, ApiErrorMessage } from './ApiClient';

export const PostLocationForceRideApi = async (trainNo: number) => {
  try {
    const response = await ApiClient.post(
      '/transits/force_ride/' + trainNo.toString(),
      {},
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
